<ng-container *transloco="let t;">
<!-- Forward signature Modal -->
<div>
    <div class="modal-header">
        <h4 class="modal-title">{{t("Forward signature modal title (Forward signature modal) - Forward signature")}}</h4>
        <button type="button" class="close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="forwardSignature" (ngSubmit)="onSubmit()">
    <div class="modal-body" tabindex="0" ngbAutofocus>
            <div class="intiveToView-fields-container">
                <div class="row">
                    <div formGroupName="recipient">
                        <div class="row">
                            <div class="col-xl-6 col-md-6 col-6 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="firstname" >{{t("First name (general) - First name")}}</label>
                                    <input type="text" class="form-control" id="firstname" formControlName="firstname" [ngClass]="{'is-invalid error': (submitted && forwardSignature.get('recipient.firstname')?.errors)}" />
                                </div>
                            </div>
                            <div class="col-xl-6 col-md-6 col-6 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="lastname" >{{t("Last name (general) - Last name")}}</label>
                                    <input type="text" class="form-control" id="lastname" formControlName="lastname" [ngClass]="{'is-invalid error': (submitted && forwardSignature.get('recipient.lastname')?.errors)}" />
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12 col-12 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="email">{{t("Email (general) - Email")}}</label>
                                    <input type="email" class="form-control" id="email"  formControlName="email" [ngClass]="{'is-invalid error': (submitted && forwardSignature.get('recipient.email')?.errors)}"/>
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12 col-12 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="phone_no">{{t("Phone (general) - Phone")}}</label>
                                    <app-phone-input [formControl]="forwardSignature.get('recipient.phone_no')" [isFormSubmitted]="submitted"></app-phone-input>
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12 col-12 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="phone_no">{{t("Personal ID number (general) - Personal ID number")}}</label>
                                    <input type="number" formControlName="persnol_no" class="form-control" id="persnol_no" mask="00000000-0000||000000-0000"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <div class="modal-footer">
        <button [disabled]="forwardSignatureLoader" type="submit" class="btn btn-primary" rippleEffect>
            {{t("Forward signature modal title (Forward signature modal) - Forward signature")}} <span *ngIf="forwardSignatureLoader" class="spinner-border spinner-border-sm ms-50"></span>
        </button>
    </div>
    </form>
</div>
<!-- / Forward signature Modal -->
</ng-container>